export default __webpack_public_path__ + "static/media/money.342b738d.svg";